module.exports = __webpack_public_path__ + "images/file_icons_v2/xlr-16214879baf7aa16d504734e15ea0d76.svg";